(function () {
    'use strict';

    angular.module('notes')
        .service('NotesService', ['$http', 'notesConfigService', 'DataService', function ($http, notesConfigService, DataService) {

            var _notes = { data: [] };

            return {
                obj: null,
                save: function (object) {
                    var that = this;
                    object.tipas = 'B';
                    return $http.put(notesConfigService.SaveNote, object).
                        success(function () {
                            that.loadNotes();
                        }).
                        error(function (data) {
                            return data;
                        });
                },
                resetNotes: function () {
                    _notes = { data: [] };
                },
                getNotes: function () {
                    return _notes;
                },
                loadNotes: function () {
                    var promise = $http.get(notesConfigService.GetNotes + this.obj.id).
                        success(function (data) {
                            _notes.data = data;
                        }).
                        error(function (data) {
                            _notes.data = data;
                        });
                    return promise;
                },
                modifyNote: function (note, onSuccess, onError) {
                    var promise = $http.post(notesConfigService.ModifyNote, note).
                        success(function (data, status, headers, config) {
                            if (angular.isDefined(onSuccess)) {
                                onSuccess(data, status, headers, config);
                            }
                        }).
                        error(function (data, status, headers, config) {
                            if (angular.isDefined(onError)) {
                                onError(data, status, headers, config);
                            }
                        });
                    return promise;
                },
                getKTTITypeId: function () {
                    var types = DataService.getNotesType();
                    for (var i = 0; i < types.length; i++) {
                        if (types[i].meaning === 'Pastabos KTTI') {
                            return types[i].id;
                        }
                    }
                }

            };
        }]);
})();
